import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface BairroData {
  id: string;
  n: string;
  pop: number;
  dom: number;
  eleit: number;
  renda: number;
  cad: number;
  votos: number;
  pct: number;
  ubs: number;
  ubsIdeal: number;
  fila: number;
  pav: number;
  escuros: number;
  creche: number;
  esgoto: number;
  pracas: number;
  nec: number;
  fill: string;
  path: string;
  lx: number;
  ly: number;
}

export interface ContatoMock {
  id: string;
  nome: string;
  tel: string;
  bairro: string;
  tags: string[];
  base: 'optin' | 'sembase' | 'optout';
  origem: string;
  cad: string;
  int: number;
  doc: string;
  niver: string;
  cons: { d: string; ip: string; dec: string };
  tl: Array<{ d: string; t: string; desc: string }>;
  lid?: string | null;
  ativo?: boolean;
  perfil?: string[];
}

export interface SolicitacaoMock {
  id: string;
  t: string;
  tema: string;
  bairro: string;
  status: 'Recebida' | 'Em análise' | 'Encaminhada' | 'Concluída';
  sla: number | null;
  cont: string;
  resp: string;
  v: number;
  aberta: string;
}

export interface AgendaItemMock {
  id: string;
  d: number;
  h: number;
  dur: number;
  t: string;
  l: string;
  k: 'e' | 'g';
  pub: boolean;
  bairro?: string;
  reag?: boolean;
  v?: number;
  alertas?: string[];
}

export interface VisitaMock {
  id: string;
  t: string;
  tipo: string;
  d: string;
  h: string;
  bairro: string;
  lid: string | null;
  part: number;
  fotos: number;
  res: string;
  prox: string;
  status: 'planejada' | 'realizada';
  participantesInternos?: string[];
  anexos?: Array<{ nome: string; tamanho: string; tipo: string }>;
}

export interface EmendaAcaoMock {
  n: string;
  v: number;
  s: 'indicado' | 'empenhado' | 'pago';
}

export interface EmendaMock {
  id: string;
  t: string;
  bairro: string;
  ben: string;
  regime: 'map' | 'pendente' | 'direto';
  acoes?: EmendaAcaoMock[];
  direto?: { ind: number; emp: number; pago: number };
  mapProposto?: Array<{ n: string; v: number }>;
}

export interface AcaoMock {
  id: string;
  t: string;
  tipo: string;
  bairro: string | null;
  tema: string;
  status: string;
  prog: number;
  valor: number | null;
  emenda: string | null;
  resolve: number;
  alc: number | null;
  com: string;
  marco: string;
}

export interface ReguaMock {
  id: string;
  n: string;
  g: string;
  p: string;
  tpl: string;
  env: number;
  resp: number;
  on: boolean;
  msg: string;
}

export interface CategoriaItemMock {
  id: string;
  nome: string;
  modulo: 'solicitacao' | 'acao' | 'agenda';
}

export interface VotoOrfaoMock {
  id: string;
  eleicao: string;
  bairro: string;
  tipo: 'branco' | 'nulo' | 'abstencao' | 'desistente';
  candidato?: string;
  votos: number;
  obs?: string;
}

export const INITIAL_CATEGORIAS: CategoriaItemMock[] = [
  { id: 'cat-1', nome: 'Saúde e Postos de Atendimento', modulo: 'solicitacao' },
  { id: 'cat-2', nome: 'Iluminação Pública e Vias', modulo: 'solicitacao' },
  { id: 'cat-3', nome: 'Agricultura / Tratores e Sementes', modulo: 'solicitacao' },
  { id: 'cat-4', nome: 'Vagas em Creches e Educação', modulo: 'solicitacao' },
  { id: 'cat-5', nome: 'Saneamento e Drenagem', modulo: 'solicitacao' },
  { id: 'cat-6', nome: 'Inauguração de Obra', modulo: 'acao' },
  { id: 'cat-7', nome: 'Entrega de Equipamentos', modulo: 'acao' },
  { id: 'cat-8', nome: 'Reunião com Lideranças Comunitárias', modulo: 'agenda' },
  { id: 'cat-9', nome: 'Visita Técnica no Território', modulo: 'agenda' },
];

export const INITIAL_VOTOS_ORFAOS: VotoOrfaoMock[] = [
  { id: 'vo-1', eleicao: '2024 · Municipal', bairro: 'messejana', tipo: 'desistente', candidato: 'Capitão Soares (Ex-Vereador)', votos: 1840, obs: 'Base aberta disputável para 2026' },
  { id: 'vo-2', eleicao: '2024 · Municipal', bairro: 'jangurussu', tipo: 'nulo', votos: 2420, obs: 'Descontentamento com postos de saúde' },
  { id: 'vo-3', eleicao: '2024 · Municipal', bairro: 'mondubim', tipo: 'branco', votos: 1530, obs: 'Falta de alternativa em creches' },
  { id: 'vo-4', eleicao: '2024 · Municipal', bairro: 'conjceara', tipo: 'abstencao', votos: 3200, obs: 'Potencial de mobilização e transporte' },
  { id: 'vo-5', eleicao: '2024 · Municipal', bairro: 'centro', tipo: 'desistente', candidato: 'Dr. Paulo Rogério (Médico)', votos: 980, obs: 'Voto de opinião na área central' },
];

export const INITIAL_BAIRROS: BairroData[] = [
  { id: 'messejana', n: 'Messejana', pop: 42318, dom: 13904, eleit: 31207, renda: 2140, cad: 28, votos: 1548, pct: 18.4, ubs: 1, ubsIdeal: 3, fila: 47, pav: 69, escuros: 112, creche: 640, esgoto: 58, pracas: 1, nec: 78, fill: '#F58406', path: 'M120 160 L220 120 L360 110 L330 220 L150 240 Z', lx: 215, ly: 175 },
  { id: 'jangurussu', n: 'Jangurussu', pop: 51804, dom: 16212, eleit: 37910, renda: 1890, cad: 34, votos: 942, pct: 11.2, ubs: 2, ubsIdeal: 4, fila: 39, pav: 61, escuros: 168, creche: 910, esgoto: 44, pracas: 2, nec: 84, fill: '#F99A2E', path: 'M360 110 L540 140 L560 230 L330 220 Z', lx: 420, ly: 175 },
  { id: 'mondubim', n: 'Mondubim', pop: 78412, dom: 24980, eleit: 56122, renda: 2010, cad: 30, votos: 824, pct: 9.8, ubs: 3, ubsIdeal: 5, fila: 35, pav: 74, escuros: 141, creche: 1120, esgoto: 52, pracas: 3, nec: 71, fill: '#FFAE3D', path: 'M180 40 L340 30 L360 110 L220 120 Z', lx: 240, ly: 85 },
  { id: 'conjceara', n: 'Conj. Ceará', pop: 44120, dom: 14302, eleit: 32860, renda: 1760, cad: 37, votos: 345, pct: 4.1, ubs: 2, ubsIdeal: 3, fila: 41, pav: 80, escuros: 77, creche: 480, esgoto: 63, pracas: 2, nec: 64, fill: '#FFD694', path: 'M40 60 L180 40 L220 120 L120 160 Z', lx: 80, ly: 110 },
  { id: 'centro', n: 'Centro', pop: 26400, dom: 11020, eleit: 24180, renda: 3610, cad: 9, votos: 210, pct: 2.5, ubs: 2, ubsIdeal: 2, fila: 18, pav: 98, escuros: 21, creche: 120, esgoto: 91, pracas: 6, nec: 22, fill: '#FFEDCF', path: 'M340 30 L520 50 L540 140 L360 110 Z', lx: 400, ly: 80 },
  { id: 'parangaba', n: 'Parangaba', pop: 31950, dom: 10780, eleit: 25410, renda: 2480, cad: 19, votos: 402, pct: 4.8, ubs: 2, ubsIdeal: 2, fila: 26, pav: 88, escuros: 48, creche: 260, esgoto: 72, pracas: 3, nec: 41, fill: '#FFC46B', path: 'M150 240 L330 220 L300 330 L100 320 Z', lx: 180, ly: 290 },
  { id: 'aldeota', n: 'Aldeota', pop: 42360, dom: 17110, eleit: 38900, renda: 7980, cad: 3, votos: 118, pct: 1.4, ubs: 1, ubsIdeal: 1, fila: 9, pav: 100, escuros: 6, creche: 40, esgoto: 99, pracas: 9, nec: 9, fill: '#FFF5E6', path: 'M330 220 L560 230 L580 330 L300 330 Z', lx: 410, ly: 290 },
  { id: 'praia', n: 'Praia do Futuro', pop: 18220, dom: 6120, eleit: 14100, renda: 2920, cad: 16, votos: 163, pct: 1.9, ubs: 1, ubsIdeal: 1, fila: 22, pav: 84, escuros: 33, creche: 150, esgoto: 67, pracas: 2, nec: 35, fill: '#FFE2B0', path: 'M520 50 L610 80 L600 210 L540 140 Z', lx: 540, ly: 150 },
];

export const BN_2024: Record<string, number> = {
  messejana: 8.4,
  jangurussu: 9.1,
  mondubim: 8.8,
  conjceara: 8.2,
  centro: 6.9,
  parangaba: 7.7,
  aldeota: 5.4,
  praia: 8.9,
};

export const FALANDO_MUN = {
  temas: [
    { t: 'Saúde / fila de postos e UPAs', n: 840, s: [32, 28, 40] },
    { t: 'Iluminação pública e pontos escuros', n: 610, s: [44, 30, 26] },
    { t: 'Vagas em creches', n: 490, s: [25, 35, 40] },
    { t: 'Saneamento básico / alagamentos', n: 380, s: [20, 32, 48] },
    { t: 'Transporte público e linhas de ônibus', n: 310, s: [35, 35, 30] },
  ],
  picos: [
    { d: '18/08', n: 210, m: 'Reclamação de iluminação na Messejana' },
    { d: '02/08', n: 180, m: 'Mutirão de saúde no Jangurussu' },
    { d: '15/07', n: 140, m: 'Falta de vagas em creches' },
  ],
};

export const BAIRROS_PATHS = INITIAL_BAIRROS;



export const INITIAL_CONTATOS: ContatoMock[] = Array.from({ length: 120 }, (_, i) => {
  const bairrosList = ['messejana', 'jangurussu', 'mondubim', 'conjceara', 'centro', 'parangaba', 'aldeota', 'praia'];
  const b = bairrosList[i % bairrosList.length]!;
  const bases: Array<'optin' | 'sembase' | 'optout'> = ['optin', 'optin', 'optin', 'sembase', 'optout'];
  const base = bases[i % bases.length]!;
  const nomes = ['Maria Francisca Silva', 'João Batista Gomes', 'Ana Cecília Souza', 'Carlos Eduardo Bento', 'Raimundo Nonato Lima', 'Francisco José Alves', 'Antônia Lúcia Martins', 'José Ribamar Costa'];
  const nome = `${nomes[i % nomes.length]} ${i + 1}`;

  return {
    id: `CT-${2700 + i}`,
    nome,
    tel: `+55 85 988${String(1000 + i).slice(0, 4)}-${String(2000 + i).slice(0, 4)}`,
    bairro: b,
    tags: i % 3 === 0 ? ['Liderança', 'Saúde'] : i % 2 === 0 ? ['Comércio'] : ['Educação'],
    base,
    origem: i % 2 === 0 ? 'Atendimento presencial' : 'WhatsApp',
    cad: '14/06/2026',
    int: (i % 10) + 1,
    doc: `***.${String(100 + i).padStart(3, '0')}.***-**`,
    niver: `${String((i % 28) + 1).padStart(2, '0')}/08`,
    cons: { d: '14/06/2026 10:22', ip: '177.136.22.4', dec: 'Termo assinado digitalmente' },
    tl: [
      { d: '21/08/2026', t: 'Mensagem enviada', desc: 'Campanha de Iluminação Pública' },
      { d: '10/08/2026', t: 'Solicitação registrada', desc: 'Reparo de asfalto na rua principal' },
      { d: '14/06/2026', t: 'Cadastro criado', desc: 'Opt-in validado via WhatsApp' },
    ],
  };
});

export const INITIAL_SOLICITACOES: SolicitacaoMock[] = [
  { id: 'SOL-01', t: 'Falta de médico no posto de saúde', tema: 'Saúde básica', bairro: 'messejana', status: 'Recebida', sla: -2, cont: 'CT-2700', resp: 'Marcos Cunha', v: 1, aberta: '15/08/2026' },
  { id: 'SOL-02', t: 'Poste apagado na Rua 12', tema: 'Iluminação e vias', bairro: 'messejana', status: 'Em análise', sla: 2, cont: 'CT-2701', resp: 'Carla Vasconcelos', v: 1, aberta: '18/08/2026' },
  { id: 'SOL-03', t: 'Falta de vagas na creche municipal', tema: 'Creche e educação', bairro: 'jangurussu', status: 'Recebida', sla: -5, cont: 'CT-2703', resp: 'Marcos Cunha', v: 1, aberta: '10/08/2026' },
  { id: 'SOL-04', t: 'Esgoto a céu aberto na Travessa 4', tema: 'Saneamento', bairro: 'mondubim', status: 'Encaminhada', sla: 6, cont: 'CT-2705', resp: 'Diego Matos', v: 1, aberta: '17/08/2026' },
  { id: 'SOL-05', t: 'Reforma da quadra poliesportiva', tema: 'Lazer e esporte', bairro: 'parangaba', status: 'Concluída', sla: null, cont: 'CT-2707', resp: 'Ana Silva', v: 2, aberta: '01/08/2026' },
];

export const INITIAL_AGENDA: AgendaItemMock[] = [
  { id: 'AG-01', d: 4, h: 9, dur: 2, t: 'Reunião com lideranças de Messejana', l: 'CRAS Messejana', k: 'g', pub: true, bairro: 'messejana', alertas: ['24h antes · WhatsApp', '2h antes · SMS'] },
  { id: 'AG-02', d: 4, h: 14, dur: 2, t: 'Vistoria nas obras da Areninha', l: 'Parangaba', k: 'g', pub: false, bairro: 'parangaba', alertas: ['24h antes · E-mail'] },
  { id: 'AG-03', d: 4, h: 18, dur: 1.5, t: 'Plenária de Prestação de Contas', l: 'Câmara Municipal', k: 'e', pub: true, bairro: 'centro', alertas: ['48h antes · WhatsApp broadcast'] },
];

export const INITIAL_VISITAS: VisitaMock[] = [
  {
    id: 'VI-01',
    t: 'Vistoria posto de saúde Messejana',
    tipo: 'Vistoria',
    d: '21/08/2026',
    h: '09:30',
    bairro: 'messejana',
    lid: 'LID-01',
    part: 14,
    fotos: 4,
    res: 'Cobrança da comunidade por mais um médico generalista e remédios para hipertensão.',
    prox: 'Ofício nº 142/2026 à SMS Fortaleza',
    status: 'realizada',
    participantesInternos: ['Vereadora Ana Silva', 'Chefe de Gabinete Paulo', 'Assessor Comunitário Marcos'],
    anexos: [
      { nome: 'ata-reuniao-posto.pdf', tamanho: '142 KB', tipo: 'pdf' },
      { nome: 'foto-vistoria-posto-1.jpg', tamanho: '1.2 MB', tipo: 'img' },
      { nome: 'foto-vistoria-posto-2.jpg', tamanho: '980 KB', tipo: 'img' }
    ]
  },
  {
    id: 'VI-02',
    t: 'Reunião com comerciantes da feira',
    tipo: 'Reunião',
    d: '22/08/2026',
    h: '15:00',
    bairro: 'parangaba',
    lid: 'LID-05',
    part: 22,
    fotos: 2,
    res: 'Demandas sobre segurança noturna e iluminação no entorno do terminal.',
    prox: 'Audiência na SEINFRA',
    status: 'realizada',
    participantesInternos: ['Vereadora Ana Silva', 'Assessor Jurídico Roberto'],
    anexos: [
      { nome: 'ata-comerciantes-feira.pdf', tamanho: '210 KB', tipo: 'pdf' },
      { nome: 'reivindicacoes-assinadas.pdf', tamanho: '850 KB', tipo: 'pdf' }
    ]
  },
  {
    id: 'VI-03',
    t: 'Caminhada no Conjunto Esperança',
    tipo: 'Caminhada',
    d: '25/08/2026',
    h: '08:00',
    bairro: 'jangurussu',
    lid: 'LID-02',
    part: 0,
    fotos: 0,
    res: '',
    prox: '',
    status: 'planejada',
    participantesInternos: ['Chefe de Gabinete Paulo', 'Assessor Comunitário Marcos'],
    anexos: []
  },
];

export const INITIAL_EMENDAS: EmendaMock[] = [
  {
    id: 'EM-2026-007',
    t: 'Reforma de praça e iluminação LED',
    bairro: 'messejana',
    ben: 'Associação Comunitária de Messejana',
    regime: 'map',
    acoes: [
      { n: 'Iluminação LED em 4 ruas', v: 80000, s: 'pago' },
      { n: 'Piso intertravado e bancos', v: 70000, s: 'empenhado' },
      { n: 'Playground infantil', v: 30000, s: 'indicado' },
    ],
  },
  {
    id: 'EM-2026-008',
    t: 'Equipamentos para posto de saúde',
    bairro: 'jangurussu',
    ben: 'Fundo Municipal de Saúde',
    regime: 'pendente',
    direto: { ind: 120000, emp: 120000, pago: 40000 },
    mapProposto: [
      { n: 'Mobiliário e ar-condicionado', v: 60000 },
      { n: 'Computadores para triagem', v: 60000 },
    ],
  },
  {
    id: 'EM-2026-009',
    t: 'Cursos profissionalizantes para jovens',
    bairro: 'mondubim',
    ben: 'Instituto Futuro Ceará',
    regime: 'direto',
    direto: { ind: 90000, emp: 50000, pago: 50000 },
  },
];

export const INITIAL_ACOES: AcaoMock[] = [
  { id: 'AC-01', t: 'Iluminação LED nas Ruas 10 a 14 de Messejana', tipo: 'Obra', bairro: 'messejana', tema: 'Iluminação e vias', status: 'Em andamento', prog: 65, valor: 80000, emenda: 'EM-2026-007', resolve: 12, alc: 3200, com: '—', marco: 'Instalação dos postes e cabeamento' },
  { id: 'AC-02', t: 'Indicação de reforma da UPA Jangurussu', tipo: 'Indicação', bairro: 'jangurussu', tema: 'Saúde básica', status: 'Em tramitação', prog: 40, valor: null, emenda: null, resolve: 8, alc: 8500, com: '—', marco: 'Aguardando parecer da comissão de saúde' },
  { id: 'AC-03', t: 'Projeto de Lei 144/2026: Incentivo ao Comércio Local', tipo: 'Projeto de lei', bairro: null, tema: 'Assistência social', status: 'Em tramitação', prog: 50, valor: null, emenda: null, resolve: 0, alc: 24000, com: '—', marco: '27/08 · votação em plenário' },
  { id: 'AC-04', t: 'Revitalização da Areninha Parangaba', tipo: 'Obra', bairro: 'parangaba', tema: 'Lazer e esporte', status: 'Concluída', prog: 100, valor: 120000, emenda: null, resolve: 15, alc: 4500, com: 'Enviado para 280 contatos opt-in', marco: 'Inaugurada' },
];

export const INITIAL_REGUAS: ReguaMock[] = [
  { id: 'RG-01', n: 'Aniversário do Apoiador', g: 'Data de aniversário (09h)', p: 'Contatos opt-in com data cadastrada', tpl: 'aniversario_parabens_v2', env: 342, resp: 89, on: true, msg: 'Olá, {{primeiro_nome}}! A vereadora Ana Silva deseja um feliz aniversário com muita saúde e realizações!' },
  { id: 'RG-02', n: 'Conclusão de Solicitação', g: 'Status da solicitação muda para "Concluída"', p: 'Cidadão solicitante', tpl: 'demanda_concluida_v1', env: 84, resp: 31, on: true, msg: 'Olá, {{primeiro_nome}}! Sua solicitação sobre {{tema}} no bairro {{bairro}} foi atendida pelo nosso gabinete. Veja detalhes em {{link}}' },
  { id: 'RG-03', n: 'Ação do Mandato no Território', g: 'Ação marcada como "Concluída"', p: 'Moradores opt-in do bairro da ação', tpl: 'acao_entregue_bairro_v1', env: 520, resp: 62, on: true, msg: 'Olá, {{primeiro_nome}}! Uma ótima notícia para {{bairro}}: {{acao}} foi concluída pelo nosso mandato!' },
  { id: 'RG-04', n: 'Reativação de Contato Inativo', g: 'Sem interação há mais de 90 dias', p: 'Base opt-in inativa', tpl: 'reativacao_mandato_v1', env: 180, resp: 14, on: false, msg: 'Olá, {{primeiro_nome}}! Queremos saber como está seu bairro. Participe da nossa pesquisa rápida de prioridades.' },
];

export const INITIAL_LIDERANCAS = [
  { id: 'LID-01', n: 'Dona Socorro Feitosa', tipo: 'Comunitária', bairro: 'messejana', area: 'Rua 12 e entornos', rec: 3, freq: 14, res: 88, saude: 92, contatos: ['CT-2700', 'CT-2701', 'CT-2702'], status: 'ativa' },
  { id: 'LID-02', n: 'Pastor Elias Moura', tipo: 'Religiosa', bairro: 'jangurussu', area: 'Conjunto Esperança', rec: 28, freq: 4, res: 40, saude: 42, contatos: ['CT-2703', 'CT-2704'], status: 'ativa' },
  { id: 'LID-03', n: 'Profª Lúcia Maia', tipo: 'Educação', bairro: 'mondubim', area: 'Estatuto dos Professores', rec: 8, freq: 9, res: 75, saude: 78, contatos: ['CT-2705'], status: 'ativa' },
  { id: 'LID-04', n: 'Zé do Gás', tipo: 'Comércio local', bairro: 'conjceara', area: '4ª Etapa', rec: 45, freq: 2, res: 20, saude: 28, contatos: ['CT-2706'], status: 'ativa' },
  { id: 'LID-05', n: 'Marcos Vale', tipo: 'Esporte/Juventude', bairro: 'parangaba', area: 'Areninha Parangaba', rec: 12, freq: 7, res: 65, saude: 70, contatos: ['CT-2707'], status: 'ativa' },
];

export const INITIAL_PESQUISAS = [
  { id: 'PQ-01', inst: 'Datafolha', per: '11–13/08/2026', met: 'Presencial · estimulada', am: 2000, abr: 'Ceará (estadual)', conf: 'alta', res: { 'Ana Silva': 14.2, 'Carlos Bento': 12.1, 'Júlia Farias': 8.9, Indecisos: 19, 'Brancos/nulos': 9 }, cen: 'Senado · 1º turno', fonte: 'Diário do Nordeste', url: 'diariodonordeste.com.br/datafolha-senado-ce', cap: 'IA · 14/08/2026', reg: 'CE-01411/2026' },
  { id: 'PQ-02', inst: 'Quaest / Genial', per: '20–24/07/2026', met: 'Presencial · estimulada · 2º turno', am: 1500, abr: 'Ceará (estadual)', conf: 'alta', res: { 'Ana Silva': 16.5, 'Carlos Bento': 13.4, 'Júlia Farias': 11.2, Indecisos: 22, 'Brancos/nulos': 11 }, cen: 'Governo do Ceará · cenário estimulado', fonte: 'O Povo', url: 'opovo.com.br/politica/quaest-julho-2026', cap: 'IA · 25/07/2026', reg: 'CE-01234/2026' },
  { id: 'PQ-03', inst: 'AtlasIntel', per: '28/07–01/08/2026', met: 'Online · recrutamento digital · estimulada', am: 1800, abr: 'Fortaleza', conf: 'média', res: { 'Ana Silva': 6.9, 'Carlos Bento': 5.0, 'Júlia Farias': 7.6, Indecisos: 25, 'Brancos/nulos': 12 }, cen: 'Câmara Municipal · estimulada', fonte: 'Folha de S.Paulo', url: 'folha.uol.com.br/atlas-fortaleza-2026', cap: 'IA · 02/08/2026', reg: 'CE-01377/2026' },
  { id: 'PQ-04', inst: 'Instituto Paraná', per: '02–05/08/2026', met: 'Telefônica · espontânea', am: 1000, abr: 'Caucaia', conf: 'média', res: { 'Ana Silva': 0, 'Carlos Bento': 0, 'Júlia Farias': 0, Indecisos: 36, 'Brancos/nulos': 14 }, cen: 'Prefeitura de Caucaia · espontânea', fonte: 'G1 Ceará', url: 'g1.globo.com/ce/parana-caucaia-2026', cap: 'IA · 07/08/2026', reg: 'CE-01390/2026' },
];

export const PESQUISAS_MOCK = INITIAL_PESQUISAS;


export const INITIAL_CV_LID: Record<string, Array<{ lid: string; votos: number }>> = {
  messejana: [{ lid: 'LID-01', votos: 700 }],
  jangurussu: [{ lid: 'LID-02', votos: 240 }],
  mondubim: [{ lid: 'LID-03', votos: 210 }],
  conjceara: [{ lid: 'LID-04', votos: 90 }],
  parangaba: [{ lid: 'LID-05', votos: 110 }],
  centro: [],
  aldeota: [],
  praia: [],
};

interface MockState {
  bairroActiveId: string;
  escala: string;
  tetoMensagens: number;
  limiarCampanha: number;
  modulos: { gab: boolean; eleg: boolean; oto: boolean };
  bairros: BairroData[];
  contatos: ContatoMock[];
  solicitacoes: SolicitacaoMock[];
  agenda: AgendaItemMock[];
  visitas: VisitaMock[];
  emendas: EmendaMock[];
  acoes: AcaoMock[];
  reguas: ReguaMock[];
  liderancas: typeof INITIAL_LIDERANCAS;
  pesquisas: typeof INITIAL_PESQUISAS;
  cvLiderancas: typeof INITIAL_CV_LID;
  campanhasEstrategicas: any[];
  cpChat: Record<string, Array<{ ag: boolean; html: string }>>;
  categorias: CategoriaItemMock[];
  votosOrfaos: VotoOrfaoMock[];
  notifTelefones: { chefe: string; parlamentar: string };

  setBairroActiveId: (id: string) => void;
  setEscala: (e: string) => void;
  setTetoMensagens: (t: number) => void;
  setLimiarCampanha: (l: number) => void;
  toggleModulo: (m: 'gab' | 'eleg' | 'oto') => void;

  addContato: (c: Omit<ContatoMock, 'id'>) => void;
  updateContatoOptin: (id: string, base: 'optin' | 'sembase' | 'optout') => void;

  addSolicitacao: (s: Omit<SolicitacaoMock, 'id'>) => void;
  moveSolicitacao: (id: string, status: SolicitacaoMock['status']) => void;
  updateSolicitacaoStatus: (id: string, status: SolicitacaoMock['status']) => void;

  addAgendaItem: (item: Omit<AgendaItemMock, 'id'>) => void;
  adiarAgendaItem: (id: string) => void;

  addVisita: (v: Omit<VisitaMock, 'id'>) => void;
  updateVisita: (id: string, updates: Partial<VisitaMock>) => void;
  updateVisitaResultado: (id: string, res: string, prox: string) => void;

  updateEmendaAcaoValor: (emendaId: string, index: number, valor: number) => void;
  updateEmendaAcaoStatus: (emendaId: string, index: number, status: EmendaAcaoMock['s']) => void;
  updateEmendaDireto: (emendaId: string, field: 'ind' | 'emp' | 'pago', valor: number) => void;
  decidirRegimeEmenda: (emendaId: string, decisao: 'migrar' | 'descartar') => void;

  addAcao: (a: Omit<AcaoMock, 'id'>) => void;
  concluirAcao: (id: string) => void;

  toggleRegua: (id: string) => void;

  updateCvVotos: (bairroId: string, lidId: string, votos: number) => void;
  addCvLideranca: (bairroId: string, lidId: string) => void;
  removeCvLideranca: (bairroId: string, lidId: string) => void;
  addCampanhaEstrategica: (camp: any) => void;
  addCpChatMessage: (campId: string, msg: { ag: boolean; html: string }) => void;
  addPesquisa: (p: any) => void;
  removeLideranca: (id: string) => void;
  toggleLiderancaStatus: (id: string) => void;
  addCategoria: (cat: Omit<CategoriaItemMock, 'id'>) => void;
  removeCategoria: (id: string) => void;
  updateNotifTelefones: (telefones: { chefe: string; parlamentar: string }) => void;
  addVotoOrfao: (voto: Omit<VotoOrfaoMock, 'id'>) => void;
}

export const useMockStore = create<MockState>()(
  persist(
    (set, get) => ({

      bairroActiveId: 'messejana',
      escala: 'ver',
      tetoMensagens: 4,
      limiarCampanha: 150,
      modulos: { gab: true, eleg: true, oto: true },
      bairros: INITIAL_BAIRROS,
      contatos: INITIAL_CONTATOS,
      solicitacoes: INITIAL_SOLICITACOES,
      agenda: INITIAL_AGENDA,
      visitas: INITIAL_VISITAS,
      emendas: INITIAL_EMENDAS,
      acoes: INITIAL_ACOES,
      reguas: INITIAL_REGUAS,
      liderancas: INITIAL_LIDERANCAS,
      pesquisas: INITIAL_PESQUISAS,
      cvLiderancas: INITIAL_CV_LID,
      categorias: INITIAL_CATEGORIAS,
      votosOrfaos: INITIAL_VOTOS_ORFAOS,
      notifTelefones: { chefe: '+55 85 98822-1100', parlamentar: '+55 85 99911-3300' },
      campanhasEstrategicas: [
        {
          id: 'CE-01',
          obj: 'Segurança em Messejana: forças externas e facções',
          tema: 'seguranca',
          d: '21/08/2026',
          resp: 198,
          n: 520,
          res: {
            id: 'CE-01',
            taxa: 38,
            resp: 198,
            n: 520,
            bairros: ['messejana', 'jangurussu'],
            segs: [
              { n: 'Concorda com o fim e com o meio', pct: 44, leit: 'alinhamento total' },
              { n: 'Concorda com o fim, mas discorda do meio', pct: 36, leit: 'apoio condicional: focar no resultado' },
              { n: 'Discorda do fim, concorda com o meio', pct: 12, leit: 'sensível a resultado prático' },
              { n: 'Discorda das duas afirmações', pct: 8, leit: 'oposição consistente' },
            ],
            porP: [
              {
                p: { q: 'Facções criminosas devem ser tratadas com rigor máximo', e: 'likert' },
                opts: ['Concordo totalmente', 'Concordo em parte', 'Neutro', 'Discordo em parte', 'Discordo totalmente'],
                tot: [92, 48, 22, 20, 16],
                resp: 198,
                dist: { messejana: [60, 30, 14, 12, 10], jangurussu: [32, 18, 8, 8, 6] },
              },
              {
                p: { q: 'A presença de forças de segurança externa no bairro é necessária', e: 'likert' },
                opts: ['Concordo totalmente', 'Concordo em parte', 'Neutro', 'Discordo em parte', 'Discordo totalmente'],
                tot: [54, 38, 24, 48, 34],
                resp: 198,
                dist: { messejana: [36, 26, 16, 32, 22], jangurussu: [18, 12, 8, 16, 12] },
              },
            ],
          },
        },
      ],
      cpChat: {},

      setBairroActiveId: (bairroActiveId) => set({ bairroActiveId }),
      setEscala: (escala) => set({ escala }),
      setTetoMensagens: (tetoMensagens) => set({ tetoMensagens }),
      setLimiarCampanha: (limiarCampanha) => set({ limiarCampanha }),

      toggleModulo: (m) =>
        set((state) => ({
          modulos: { ...state.modulos, [m]: !state.modulos[m] },
        })),

      addContato: (c) =>
        set((state) => ({
          contatos: [
            {
              ...c,
              id: `CT-${2700 + state.contatos.length}`,
            },
            ...state.contatos,
          ],
        })),

      updateContatoOptin: (id, base) =>
        set((state) => ({
          contatos: state.contatos.map((c) =>
            c.id === id
              ? {
                  ...c,
                  base,
                  cons: {
                    d: new Date().toLocaleString('pt-BR'),
                    ip: '177.136.22.4',
                    dec: base === 'optin' ? 'Opt-in coletado via termo' : 'Opt-out solicitado',
                  },
                }
              : c
          ),
        })),

      addSolicitacao: (s) =>
        set((state) => ({
          solicitacoes: [
            {
              ...s,
              id: `SOL-${String(state.solicitacoes.length + 1).padStart(2, '0')}`,
            },
            ...state.solicitacoes,
          ],
        })),

      moveSolicitacao: (id, status) =>
        set((state) => ({
          solicitacoes: state.solicitacoes.map((s) =>
            s.id === id
              ? {
                  ...s,
                  status,
                  sla: status === 'Concluída' ? null : s.sla,
                  v: (s.v || 1) + 1,
                }
              : s
          ),
        })),

      updateSolicitacaoStatus: (id, status) =>
        set((state) => ({
          solicitacoes: state.solicitacoes.map((s) =>
            s.id === id
              ? {
                  ...s,
                  status,
                  sla: status === 'Concluída' ? null : s.sla,
                  v: (s.v || 1) + 1,
                }
              : s
          ),
        })),

      addAgendaItem: (item) =>
        set((state) => ({
          agenda: [
            {
              ...item,
              id: `AG-${String(state.agenda.length + 1).padStart(2, '0')}`,
            },
            ...state.agenda,
          ],
        })),

      adiarAgendaItem: (id) =>
        set((state) => ({
          agenda: state.agenda.map((a) =>
            a.id === id
              ? {
                  ...a,
                  d: (a.d + 1) % 5,
                  reag: true,
                  v: (a.v || 1) + 1,
                  alertas: [
                    'Reagendado em cascata (v2)',
                    'Lembrete 24h antes atualizado',
                  ],
                }
              : a
          ),
        })),

      addVisita: (v) =>
        set((state) => ({
          visitas: [
            {
              ...v,
              id: `VI-${String(state.visitas.length + 1).padStart(2, '0')}`,
            },
            ...state.visitas,
          ],
        })),

      updateVisita: (id, updates) =>
        set((state) => ({
          visitas: state.visitas.map((v) =>
            v.id === id ? { ...v, ...updates } : v
          ),
        })),

      updateVisitaResultado: (id, res, prox) =>
        set((state) => ({
          visitas: state.visitas.map((v) =>
            v.id === id
              ? {
                  ...v,
                  res,
                  prox,
                  status: 'realizada',
                }
              : v
          ),
        })),

      updateEmendaAcaoValor: (emendaId, index, valor) =>
        set((state) => ({
          emendas: state.emendas.map((e) => {
            if (e.id !== emendaId || !e.acoes) return e;
            const novasAcoes = [...e.acoes];
            if (novasAcoes[index]) {
              novasAcoes[index] = { ...novasAcoes[index], v: valor };
            }
            return { ...e, acoes: novasAcoes };
          }),
        })),

      updateEmendaAcaoStatus: (emendaId, index, status) =>
        set((state) => ({
          emendas: state.emendas.map((e) => {
            if (e.id !== emendaId || !e.acoes) return e;
            const novasAcoes = [...e.acoes];
            if (novasAcoes[index]) {
              novasAcoes[index] = { ...novasAcoes[index], s: status };
            }
            return { ...e, acoes: novasAcoes };
          }),
        })),

      updateEmendaDireto: (emendaId, field, valor) =>
        set((state) => ({
          emendas: state.emendas.map((e) => {
            if (e.id !== emendaId || !e.direto) return e;
            return {
              ...e,
              direto: {
                ...e.direto,
                [field]: valor,
              },
            };
          }),
        })),

      decidirRegimeEmenda: (emendaId, decisao) =>
        set((state) => ({
          emendas: state.emendas.map((e) => {
            if (e.id !== emendaId) return e;
            if (decisao === 'migrar') {
              return {
                ...e,
                regime: 'map',
                acoes: [
                  { n: 'Mobiliário e ar-condicionado', v: 60000, s: 'pago' },
                  { n: 'Computadores para triagem', v: 60000, s: 'empenhado' },
                ],
                mapProposto: undefined,
              };
            }
            return {
              ...e,
              regime: 'direto',
              mapProposto: undefined,
            };
          }),
        })),

      addAcao: (a) =>
        set((state) => ({
          acoes: [
            {
              ...a,
              id: `AC-${String(state.acoes.length + 1).padStart(2, '0')}`,
            },
            ...state.acoes,
          ],
        })),

      concluirAcao: (id) =>
        set((state) => ({
          acoes: state.acoes.map((a) =>
            a.id === id
              ? {
                  ...a,
                  status: 'Concluída',
                  prog: 100,
                  com: 'Enviado para base opt-in',
                  marco: 'Concluída',
                }
              : a
          ),
        })),

      toggleRegua: (id) =>
        set((state) => ({
          reguas: state.reguas.map((r) =>
            r.id === id ? { ...r, on: !r.on } : r
          ),
        })),

      updateCvVotos: (bairroId, lidId, votos) => {
        const current = { ...get().cvLiderancas };
        const list = current[bairroId] || [];
        const item = list.find((x) => x.lid === lidId);
        if (item) {
          item.votos = votos;
          set({ cvLiderancas: current });
        }
      },

      addCvLideranca: (bairroId, lidId) => {
        const current = { ...get().cvLiderancas };
        current[bairroId] = current[bairroId] || [];
        if (!current[bairroId].some((x) => x.lid === lidId)) {
          const bairro = get().bairros.find((b) => b.id === bairroId);
          const histVotos = bairro ? Math.round(bairro.votos * 0.15) : 100;
          current[bairroId].push({ lid: lidId, votos: histVotos });
          set({ cvLiderancas: current });
        }
      },

      removeCvLideranca: (bairroId, lidId) => {
        const current = { ...get().cvLiderancas };
        if (current[bairroId]) {
          current[bairroId] = current[bairroId].filter((x) => x.lid !== lidId);
          set({ cvLiderancas: current });
        }
      },

      addCampanhaEstrategica: (camp) => {
        set((state) => ({
          campanhasEstrategicas: [camp, ...state.campanhasEstrategicas],
        }));
      },

      addCpChatMessage: (campId, msg) => {
        const current = { ...get().cpChat };
        current[campId] = current[campId] || [];
        current[campId].push(msg);
        set({ cpChat: current });
      },

      addPesquisa: (p) => {
        set((state) => ({
          pesquisas: [
            {
              ...p,
              id: p.id || `PQ-${String(state.pesquisas.length + 1).padStart(2, '0')}`,
            },
            ...state.pesquisas,
          ],
        }));
      },

      removeLideranca: (id) => {
        set((state) => ({
          liderancas: state.liderancas.filter((l) => l.id !== id),
        }));
      },

      toggleLiderancaStatus: (id) => {
        set((state) => ({
          liderancas: state.liderancas.map((l) =>
            l.id === id ? { ...l, status: l.status === 'ativa' ? 'inativa' : 'ativa' } : l
          ),
        }));
      },

      addCategoria: (cat) => {
        set((state) => ({
          categorias: [
            ...state.categorias,
            { ...cat, id: `cat-${Date.now()}` },
          ],
        }));
      },

      removeCategoria: (id) => {
        set((state) => ({
          categorias: state.categorias.filter((c) => c.id !== id),
        }));
      },

      updateNotifTelefones: (telefones) => {
        set({ notifTelefones: telefones });
      },

      addVotoOrfao: (voto) => {
        set((state) => ({
          votosOrfaos: [
            { ...voto, id: `vo-${Date.now()}` },
            ...state.votosOrfaos,
          ],
        }));
      },
    }),
    { name: 'mandato360-mock-data' }
  )
);
